function normalizeText(value) {
  return String(value || '').trim().toLowerCase();
}

function buildLineKey(line) {
  return String(line?.code || '').trim() || normalizeText(line?.name);
}

function compareByCode(a, b) {
  return String(a.code || '').localeCompare(String(b.code || ''), undefined, { numeric: true, sensitivity: 'base' });
}

const LABELS = {
  tr: {
    reportTitle: 'Dipnotlar',
    statementName: 'IFRS Dipnot Dizini',
    noComparative: 'Karsilastirmali onceki donem dipnot verisi bulunamadi.',
    basisNote: 'Sunum, approved IFRS batch icindeki dipnot basliklari ve dipnot tablolarini profesyonel bir dipnot dizini formatinda listeler.',
    noteCode: 'Dipnot Kodu',
    noteTitle: 'Dipnot Basligi',
    tables: 'Bagli Tablolar',
    currentTables: 'Cari Donem Tablolari',
    previousTables: 'Onceki Donem Tablolari',
    noteCount: 'Dipnot Sayisi',
    tableCount: 'Tablo Sayisi',
    totalNotes: 'TOPLAM DIPNOT',
    totalTables: 'TOPLAM DIPNOT TABLOSU',
    notAvailable: 'Bulunmuyor',
    previousOnly: 'Sadece onceki donemde',
    currentOnly: 'Sadece cari donemde',
    bothPeriods: 'Her iki donemde'
  },
  en: {
    reportTitle: 'Notes',
    statementName: 'IFRS Notes Index',
    noComparative: 'No comparative previous-period notes data was found.',
    basisNote: 'Presentation lists note headings and note tables from the approved IFRS batch in a professional notes-index format.',
    noteCode: 'Note Code',
    noteTitle: 'Note Title',
    tables: 'Related Tables',
    currentTables: 'Current-period Tables',
    previousTables: 'Previous-period Tables',
    noteCount: 'Note Count',
    tableCount: 'Table Count',
    totalNotes: 'TOTAL NOTES',
    totalTables: 'TOTAL NOTE TABLES',
    notAvailable: 'Not available',
    previousOnly: 'Previous period only',
    currentOnly: 'Current period only',
    bothPeriods: 'Both periods'
  }
};

function parseNotes(lines) {
  const notes = new Map();

  (lines || []).forEach((line) => {
    const type = String(line?.accountType || '').trim().toUpperCase();
    const code = String(line?.code || '').trim();
    const name = String(line?.name || '').trim();
    if (!code) return;

    if (type === 'NOTE_INSTANCE' || type === 'NOTE_TEMPLATE') {
      notes.set(buildLineKey(line), {
        key: buildLineKey(line),
        code,
        title: name || code,
        sourceType: type,
        tables: []
      });
      return;
    }

    if (type === 'NOTE_TABLE') {
      const noteCode = code.includes('_') ? code.split('_')[0] : code;
      const noteKey = noteCode || code;
      const existing = notes.get(noteKey) || {
        key: noteKey,
        code: noteCode || code,
        title: noteCode || code,
        sourceType: 'NOTE_INSTANCE',
        tables: []
      };
      existing.tables.push({
        key: code,
        code,
        title: name || code
      });
      notes.set(noteKey, existing);
    }
  });

  return [...notes.values()].sort(compareByCode);
}

export function buildNotesPresentation({
  currentReport,
  previousReport,
  currentPeriodLabel,
  previousPeriodLabel,
  isTr
}) {
  const labels = isTr ? LABELS.tr : LABELS.en;
  const currentNotes = parseNotes(currentReport?.lines || []);
  const previousNotes = parseNotes(previousReport?.lines || []);
  const previousByCode = new Map(previousNotes.map((note) => [note.code, note]));

  const noteItems = currentNotes.map((note) => {
    const previous = previousByCode.get(note.code);
    return {
      ...note,
      currentTableCount: note.tables.length,
      previousTableCount: previous?.tables?.length || 0,
      statusLabel: previous
        ? labels.bothPeriods
        : labels.currentOnly
    };
  });

  previousNotes.forEach((note) => {
    if (noteItems.some((item) => item.code === note.code)) {
      return;
    }
    noteItems.push({
      ...note,
      currentTableCount: 0,
      previousTableCount: note.tables.length,
      statusLabel: labels.previousOnly
    });
  });

  noteItems.sort(compareByCode);

  return {
    viewType: 'notes',
    labels,
    currentPeriodLabel: currentPeriodLabel || '',
    previousPeriodLabel: previousPeriodLabel || '',
    comparativeAvailable: Boolean(previousReport?.lines?.length),
    metadataNote: labels.basisNote,
    notes: noteItems,
    stats: {
      noteCount: noteItems.length,
      tableCount: noteItems.reduce((total, item) => total + item.currentTableCount, 0)
    }
  };
}
